import { createContext, useReducer, useEffect, useState } from 'react';
import { PropertyApi } from 'services/api/property';
import { cloneDeep } from 'lodash';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import {useUser} from 'contexts/UserContext';
import { format } from 'date-fns';

const dateWithin7Days = (dateType) => {
return differenceInCalendarDays(new Date(dateType), new Date()) <= 7 &&
differenceInCalendarDays(new Date(dateType), new Date()) > -1;
}


const initialState = {
    loading: true,
    error: '',
    data: [],
};

const reducer = (propertiesState, action) => {
    const propertiesStateCopy = cloneDeep(propertiesState);
    switch (action.type) {
        case 'FETCH_SUCCESS':
            return {
                loading: false,
                error: '',
                data: action.payload
            };
        case 'FETCH_FAILURE':
            return {
                loading: false,
                error: 'There was an error fetching data.',
                data: []
            };
        case 'CLEAR_DATA':
            return initialState;
        case 'ADD_PROPERTY':
            // console.log('addproperty', action.payload)
            const newProperties = [...propertiesState.data, {...action.payload}]
            propertiesStateCopy.data = newProperties
            return propertiesStateCopy;
        case 'UPDATE_PROPERTY':
            const indexToEdit = propertiesState.data.findIndex((prop) => prop.id === action.payload.id)
            propertiesStateCopy.data[indexToEdit] = action.payload
            return propertiesStateCopy
        case 'ADD_TENANT':
            const propToEdit = propertiesState.data.findIndex((prop) => prop.id === action.payload.property.id)
            const rmToEdit = propertiesState.data[propToEdit].rooms.findIndex((room) => room.id === action.payload.room.id)
            const newTenant = { ...action.payload.tenant, name: action.payload.tenant.firstName + ' ' + action.payload.tenant.lastName, moveIn: format(new Date(action.payload.tenant.moveIn), "yyyy-MM-dd"), moveOut: format(new Date(action.payload.tenant.moveOut), "yyyy-MM-dd"), movingInWithin7Days: dateWithin7Days(action.payload.tenant.moveIn), movingOutWithin7Days: dateWithin7Days(action.payload.tenant.moveOut)}
            if (rmToEdit !== -1) {
                propertiesStateCopy.data[propToEdit].rooms[rmToEdit].tenants.push(newTenant)
            } else {
                propertiesStateCopy.data[propToEdit].rooms.push({ ...action.payload.room, tenants: [newTenant]})
            }
            return propertiesStateCopy
        case 'UPDATE_TENANT':
            const propertyToEdit = propertiesState.data.findIndex((prop) => prop.id === action.payload.property.id);
            const roomToEdit = propertiesState.data[propertyToEdit].rooms.findIndex((room) => room.id === action.payload.tenant.room.id)
            const tenantToEdit = propertiesState.data[propertyToEdit].rooms[roomToEdit].tenants.findIndex((tenant) => tenant.id === action.payload.tenant.id);
            const updatedTenant = { ...action.payload.tenant, name: action.payload.tenant.firstName + ' ' + action.payload.tenant.lastName, movingInWithin7Days: dateWithin7Days(action.payload.tenant.moveIn), movingOutWithin7Days: dateWithin7Days(action.payload.tenant.moveOut)}
            propertiesStateCopy.data[propertyToEdit].rooms[roomToEdit].tenants[tenantToEdit] = updatedTenant;
            return propertiesStateCopy;
        case 'ARCHIVE_PROPERTY':
            return {...propertiesState, data: propertiesState.data.filter(p => p.id !== action.payload)}
        default:
            return propertiesState;
    }
  }

export const PropertiesContext = createContext(initialState);

export const PropertiesContextProvider = ({ children }) => {
    const [propertiesState, propertiesDispatch] = useReducer(reducer, initialState);
    const [user, setUser] = useState(undefined)
    const getUser = useUser()

    useEffect(() => {
        if(getUser?.user?.userType === 'landlord'){ 
            // console.log("found user", getUser.user.userType);
            user !== getUser && setUser(getUser.user)
        }
    }, [getUser])
    useEffect(() => {
           if (user) {
            propertiesDispatch({type: 'CLEAR_DATA'})
            // console.log('New Fetch - getProperties')
            PropertyApi.getProperties()
            .then(res => propertiesDispatch({type: 'FETCH_SUCCESS', payload: res.data}))
            .catch(err => propertiesDispatch({type: 'FETCH_FAILURE'}));
        }
    }, [user]);
    

  return (
    <PropertiesContext.Provider value={{ state: propertiesState, dispatch: propertiesDispatch}}>
      {children}
    </PropertiesContext.Provider>
  );
};
